import { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import Loading from 'pages/loading/Loading';
import Cookies from 'universal-cookie';
import { DOCS, HOME_PAGE, THU_VIEN_VIDEO, THU_VIEN_HINH_ANH, ORDER_PAGE, RESULT_PAGE, TIN_TUC_NOI_BO, TIN_TUC_NOI_BO_DETAIL, TIN_TUC_DETAIL, VNPT_NET_ONLINE, VNPT_NET_ONLINE_DETAIL, NEWS, MEDIA, HIEN_KE } from 'constants/routes';
import 'assets/css/app.scss';
import { useStore } from './store';
import { useSelector, useDispatch } from 'react-redux';
import { login } from '../src/store/slices/auth'; 
import { Notification } from 'components/common/Notification/Notification';

import dayjs from 'dayjs';

const Layout = lazy(() => import('components/pages/Layout/Layout'));
const Home = lazy(() => import('pages/home/Home'));
const ListNews = lazy(() => import('pages/news/ListNews'));
const NewsDetail = lazy(() => import('pages/news/NewsDetail'));

const VNPTNetOnline = lazy(() => import('pages/vnptnetonline/VNPTNetOnline'));
const VNPTNetOnlineDetail = lazy(() => import('pages/vnptnetonline/VNPTNetOnlineDetail'));
const ListMedia = lazy(() => import('pages/media/ListMedia'));
const MediaDetail = lazy(() => import('pages/media/MediaDetail'));
const ListDocs = lazy(() => import('pages/docs/ListDocs'));
const DocsDetail = lazy(() => import('pages/docs/DocsDetail'));
const Idea = lazy(() => import('pages/ideas/Idea'));

var customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

function App() {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const [param] = useSearchParams();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const store = useStore(); 

  if (!store) {
    console.error('Store is not defined.');
  }
  useEffect(() => {
    const ticket = param.get('ticket');
    if (!isLoggedIn && !ticket) {
      const loginUrl = `https://id.vnpt.com.vn/cas/login?service=${process.env.REACT_APP_LOGIN_URL}`;
      window.location.replace(loginUrl);
      return; 
    }
  
    if (ticket && !isLoggedIn) {
      setIsProcessing(true);
      let payload = {};
       payload.ticket = ticket;
        dispatch(login(payload))       
        .unwrap()
        .then((res) => {
          if (res.error_code || res.error_code !== undefined) {
            Notification.error(res.message);
          } if (res.token && res.token !== undefined)  {
            Notification.success(" Đăng nhập thành công!");
            navigate("/", { replace: true }); 
          }
        })
        .catch(() => {
          console.log(false);
          Notification.error(" Đăng nhập thất bại");
        })
        .finally(() => {
          setIsProcessing(false);
        });
    }
  }, [isLoggedIn, dispatch, navigate, param]);
  

  return (
    <Suspense fallback={<Loading />}>
    {!isLoggedIn || isProcessing ? (
      <Loading />
    ) : (
      <Routes>
        <Route path={HOME_PAGE} element={<Layout />}>
          <Route index element={<Home />} />
          <Route path={":cate"} element={<ListNews />} />
          <Route path={":cate/:id"} element={<NewsDetail />} />
          <Route path={VNPT_NET_ONLINE} element={<VNPTNetOnline />} />
          <Route path={VNPT_NET_ONLINE_DETAIL} element={<VNPTNetOnlineDetail />} />
          <Route path={THU_VIEN_HINH_ANH} element={<ListMedia />} />
          <Route path={THU_VIEN_VIDEO} element={<ListMedia />} />
          <Route path={THU_VIEN_HINH_ANH + "/:id"} element={<MediaDetail />} />
          <Route path={THU_VIEN_VIDEO + "/:id"} element={<MediaDetail />} />
          <Route path={DOCS} element={<ListDocs />} />
          <Route path={DOCS + "/:id"} element={<DocsDetail />} />
          <Route path={HIEN_KE} element={<Idea />} />
          <Route path={HIEN_KE + "/:id"} element={<DocsDetail />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    )}
    </Suspense>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter basename='/'>
      <App />
    </BrowserRouter>
  );
}

export default AppWrapper;
